"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CartListItem = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _button = require("../button");

var _select = _interopRequireDefault(require("../select"));

var _icon = require("../icon");

var _iconScale = _interopRequireDefault(require("./assets/icon-scale.svg"));

require("./index.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Option = _select.default.Option;

var CartListItem = function CartListItem(_ref) {
  var type = _ref.type,
      photoUrl = _ref.photoUrl,
      title = _ref.title,
      desc = _ref.desc,
      disableDelete = _ref.disableDelete,
      color = _ref.color,
      material = _ref.material,
      price = _ref.price,
      stock = _ref.stock,
      value = _ref.value,
      defaultStockValue = _ref.defaultStockValue,
      style = _ref.style,
      onChange = _ref.onChange,
      onDelete = _ref.onDelete,
      onThumbClick = _ref.onThumbClick,
      variantSelector = _ref.variantSelector;

  function getChildren() {
    var children = [];

    for (var i = 1; i < Number(stock) + 1; i += 1) {
      children.push( /*#__PURE__*/_react.default.createElement(Option, {
        key: i
      }, i));
    }

    return children;
  }

  function getThumbnail() {
    var photoItem = {};

    var thumbnail = /*#__PURE__*/_react.default.createElement("img", {
      className: "shpmtc-cart-list__photo",
      src: photoUrl,
      alt: ""
    });

    if (onThumbClick === null) {
      photoItem = thumbnail;
    } else {
      photoItem = /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "shpmtc-cart-list__thumbnail-button",
        onClick: onThumbClick || null
      }, /*#__PURE__*/_react.default.createElement("img", {
        className: "icon-scale",
        src: _iconScale.default,
        alt: ""
      }), thumbnail);
    }

    return photoItem;
  } // Color / Marterial


  var thumb = null;

  if (color) {
    thumb = /*#__PURE__*/_react.default.createElement("span", {
      className: "desc__thumb",
      style: {
        backgroundColor: color
      }
    });
  }

  if (material) {
    thumb = /*#__PURE__*/_react.default.createElement("span", {
      className: "desc__thumb",
      style: {
        backgroundImage: "url(".concat(material, ")")
      }
    });
  } // Varient selector handler


  var varientSlectHandler = variantSelector ? {
    onClick: function onClick() {
      return variantSelector();
    }
  } : null;
  return /*#__PURE__*/_react.default.createElement("section", {
    className: "\n        shpmtc-cart-list ".concat(type === 'simple' ? 'shpmtc-cart-list--simple' : '', "\n      "),
    style: style
  }, getThumbnail(), /*#__PURE__*/_react.default.createElement("div", {
    className: "shpmtc-cart-list__content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "\n            shpmtc-cart-list__content__info \n            ".concat(disableDelete ? 'shpmtc-cart-list__content__info--full' : '', "\n          ")
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "title"
  }, title), (desc || thumb) && /*#__PURE__*/_react.default.createElement("div", _extends({
    className: "\n                desc ".concat(variantSelector ? 'varient-selector' : '', "\n              ")
  }, varientSlectHandler), thumb, /*#__PURE__*/_react.default.createElement("span", {
    className: "desc__info"
  }, desc), variantSelector ? /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    className: "dropdown-icon",
    type: "shpmtcdicon-arrow-down"
  }) : null)), /*#__PURE__*/_react.default.createElement("div", {
    className: "shpmtc-cart-list__content__bottom"
  }, type !== 'simple' ? /*#__PURE__*/_react.default.createElement(_select.default, {
    style: {
      width: 85
    },
    defaultValue: defaultStockValue,
    value: value,
    onChange: onChange,
    notFoundContent: "No results"
  }, getChildren()) : null, /*#__PURE__*/_react.default.createElement("p", {
    className: "price"
  }, price))), disableDelete === true ? null : /*#__PURE__*/_react.default.createElement(_button.Button, {
    className: "shpmtc-cart-list__delete",
    type: "Icon",
    onClick: onDelete
  }, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    type: "shpmtcdicon-trash"
  })));
}; // Prop Types


exports.CartListItem = CartListItem;
CartListItem.defaultProps = {
  type: null,
  photoUrl: '',
  title: '',
  desc: '',
  disableDelete: null,
  color: null,
  material: null,
  price: '',
  stock: null,
  value: '1',
  defaultStockValue: '1',
  style: null,
  onChange: null,
  onDelete: null,
  onThumbClick: null,
  variantSelector: null
};
CartListItem.propTypes = {
  type: _propTypes.default.string,
  photoUrl: _propTypes.default.string,
  title: _propTypes.default.string,
  desc: _propTypes.default.string,
  disableDelete: _propTypes.default.bool,
  color: _propTypes.default.string,
  material: _propTypes.default.string,
  price: _propTypes.default.string,
  stock: _propTypes.default.string,
  value: _propTypes.default.string,
  defaultStockValue: _propTypes.default.string,
  style: _propTypes.default.instanceOf(Object),
  onChange: _propTypes.default.func,
  onDelete: _propTypes.default.func,
  onThumbClick: _propTypes.default.func,
  variantSelector: _propTypes.default.func
};